import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { persistReducer,persistStore } from 'redux-persist';
import storageSession from 'redux-persist/lib/storage/session';

import authSlice from './slices/authSlice';
import notesSlice from './slices/notesSlice';
import userSlice from './slices/userSlice';
import waitlistPreferencesSlice from './slices/waitlistPreferencesSlice';
import waitlistSlice from './slices/waitlistSlice';

const persistConfig = {
  key: 'root',
  storage: storageSession,
  whitelist: ['auth', 'user', 'waitlist'],
};

// Separate persist config for waitlist to only persist specific fields
const waitlistPersistConfig = {
  key: 'waitlist',
  storage: storageSession,
  whitelist: ['filterData', 'activeFilters', 'propertyTagManagement'], // Only persist filter-related state and tag management
};

const rootReducer = combineReducers({
  auth: authSlice,
  user: userSlice,
  waitlist: persistReducer(waitlistPersistConfig, waitlistSlice),
  notes: notesSlice,
  waitlistPreferences: waitlistPreferencesSlice,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
      },
    }),
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch; 